<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>

    <section v-if="page == 1">
      <div class="col-12" style="padding-left: 5px; padding-right: 5px">
        <div
          class="card card-style"
          style="background-color: white; margin-left: 0px; margin-right: 0px"
        >
          <div class="card-body mb-5">
            <div class="form-group">
              <h3 class="card-title">
                Atendimento #{{ atendimento.ocorrencia_id }}
              </h3>
            </div>

            <div class="row mt-4 mb-4">
              <div class="col-1 ml-2 centered">
                <span class="circulo"></span>
              </div>
              <div class="col-11 ml-2" style="margin-top: -2px !important">
                <span class="font-18">{{
                  atendimento.status_desc
                    ? atendimento.status_desc.nome
                    : "Aguardando atendimento"
                }}</span>
              </div>
            </div>

            <!-- <div class="form-group">
                            <label for="inputField" class="col-form-label">Latitude:</label>
                            <div class="custom-input-container">
                                <input type="text" style="background-color: #efefef ;" v-model="geo.latitude" class="custom-input" :disabled="isDisabled"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="inputField" class="col-form-label">Longitude:</label>
                            <div class="custom-input-container">
                                <input type="text" style="background-color: #efefef ;" v-model="geo.longitude" class="custom-input" :disabled="isDisabled"/>
                            </div>
                        </div> -->

            <!-- <h3 class="card-title" style="text-align: center;">Solicitar Atendimento</h3> -->
            <div class="form-group">
              <label for="inputField" class="col-form-label"
                >Data Solicitação:</label
              >
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  v-model="atendimento.data_gravacao"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label"
                >Solicitante:</label
              >
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="
                    atendimento.solicitante
                      ? atendimento.solicitante.usuario_nome
                      : ''
                  "
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">Vítima:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="
                    atendimento.paciente
                      ? atendimento.paciente.nome_paciente
                      : atendimento.paciente_solicitado
                  "
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">Idade:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="
                    atendimento.paciente
                      ? atendimento.paciente.idade
                      : 'Não informado'
                  "
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">Sexo:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="
                    atendimento.paciente
                      ? atendimento.paciente.sexo
                      : 'Não informado'
                  "
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label
                for="inputField"
                style="font-weight: bold"
                class="col-form-label"
                >Queixa Principal:</label
              >
              <div class="custom-input-container">
                <textarea
                  :disabled="true"
                  v-model="atendimento.queixa_principal"
                  style="height: 83px; background-color: #efefef"
                  maxlength="260"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">CEP:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="atendimento.cep"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">Logradouro:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="atendimento.logradouro"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">Número:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="atendimento.numero"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">Bairro:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="atendimento.bairro"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">Cidade:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="atendimento.cidade"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label">UF:</label>
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="atendimento.uf"
                  class="custom-input"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="inputField" class="col-form-label"
                >Complemento:</label
              >
              <div class="custom-input-container">
                <input
                  type="text"
                  style="background-color: #efefef"
                  :disabled="true"
                  :value="atendimento.complemento"
                  class="custom-input"
                />
              </div>
            </div>
            <br />
            <!-- <div class="form-group botao-solicitar">
                          <div class="col-md-12">
                            <button type="button" class="btn">SOLICITAR</button>
                          </div>
                        </div> -->

            <div class="form-group col-md-12">
              <GmapMap
                :center="{ lat: position.lat, lng: position.lng }"
                :options="{
                  zoomControl: true,
                  streetViewControl: false,
                  mapTypeControl: false,
                  fullscreenControl: false,
                }"
                :zoom="16"
                map-type-id="roadmap"
                style="
                  width: auto;
                  height: 200px;
                  border-radius: 50px !important;
                "
              >
                <GmapMarker :position="position"></GmapMarker>
              </GmapMap>
            </div>
          </div>
          <div class="form-group botao-solicitar">
            <div class="col-12">
              <button
                class="btn ml-5"
                @click="(page = 2), rolar()"
                style="z-index: 9999999999px !important"
              >
                Ver Chat
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="page == 2">
      <div
        class="card card-style"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body">
          <div class="chat">
            <div v-if="atendimento">
              <div class="chat-header clearfix">
                <div class="row">
                  <div class="col-2">
                    <a
                      href="javascript:void(0);"
                      data-toggle="modal"
                      data-target="#view_info"
                    >
                      <img :src="atendimento.solicitante.foto" alt="avatar" />
                    </a>
                  </div>
                  <div class="col-9">
                    <div class="chat-about">
                      <h6 class="m-b-0">Operador SAMU</h6>
                      <!-- <small>Online {{ user.usuario_nome }}</small> -->
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="chat-history"
                id="chat-messages"
                style="overflow: auto; max-height: 350px"
              >
                <ul class="m-b-0">
                  <li
                    class="clearfix"
                    v-for="message in messages"
                    :key="message.mensagem_id"
                  >
                    <div
                      class="message-data"
                      :class="
                        user.usuario_id == message.usuario_id
                          ? 'text-right'
                          : 'text-left'
                      "
                    >
                      <span class="message-data-time">{{
                        moment(message.enviado_em).fromNow()
                      }}</span>
                    </div>
                    <div
                      class="message"
                      :class="
                        user.usuario_id == message.usuario_id
                          ? 'other-message float-right'
                          : 'my-message float-left'
                      "
                    >
                      {{ message.mensagem }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="chat-message clearfix">
                <div class="input-group mb-0">
                  <div
                    class="input-group-prepend"
                    style="cursor: pointer"
                    @click="sendMessage"
                    v-if="atendimento.status != 9"
                  >
                    <span class="input-group-text"
                      ><i class="fas fa-paper-plane"></i
                    ></span>
                  </div>
                  <input
                    :disabled="atendimento.status === 9 || sending_message"
                    type="text"
                    class="form-control"
                    placeholder="Mensagem..."
                    v-model="message"
                    v-on:keyup.enter="sendMessage"
                    id="message_area"
                  />
                </div>
              </div>
              <div v-if="atendimento.status === 9" class="finalized-message">
                O atendimento está finalizado. Não é possível enviar mais
                mensagens.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import vSelect from "vue-select";
import moment from "moment";
/* import GmapMap from 'vue2-google-maps'; */
export default {
  data() {
    return {
      page: 1,
      sending_message: false,
      moment: moment,
      loaded: false,
      messages: [],
      message: "",
      user: {},
      position: {
        lat: 0,
        lng: 0,
      },
      atendimento: {
        status: 0,
        data_gravacao: "",
        paciente: "",
        solicitante: {
          usuario_nome: "",
          nome_paciente: "",
          idade: "",
          sexo: "",
          queixa_principal: "",
        },
        ocorrencia_id: "",
        latitude: 0,
        longitude: 0,
      },
      isDisabled: true,
      isLoading: false,
      loadingColor: "#5D9CEC",
    };
  },
  computed: {},
  methods: {
    rolar() {
      setTimeout(() => {
        $("#chat-messages").scrollTop($("#chat-messages")[0].scrollHeight);
      }, 1000);
    },
    sendMessage: function () {
      const self = this;
      const api = self.$store.state.api + "chat/send-message";

      self.sending_message = true;

      axios
        .post(api, {
          mensagem: self.message,
          ocorrencia_id: self.$route.params.id,
        })
        .then((response) => {
          self.message = "";
          self.sending_message = false;
          self.getMessages();
          setTimeout(() => {
            $("#message_area").focus();
          }, 500);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.sending_message = false;
        });
    },
    readMessages: function () {
      const self = this;
      const api = self.$store.state.api + "chat/read-messages";

      axios
        .post(api, {
          ocorrencia_id: self.$route.params.id,
        })
        .then((response) => {})
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    playSound(volume) {
      var audio = new Audio(
        "https://soundbible.com/mp3/Air%20Plane%20Ding-SoundBible.com-496729130.mp3"
      );
      if (volume == null || volume == undefined) {
        volume = 0;
      }
      audio.volume = volume;
      audio.play();
    },
    getMessages() {
      const self = this;

      const api =
        self.$store.state.api +
        "chat_messages?paginated=false&with[]=usuario&ocorrencia_id=" +
        self.atendimento.ocorrencia_id;
      axios
        .get(api)
        .then((response) => {
          self.messages = response.data.data;
          self.rolar();
          self.readMessages();
          self.loaded = true;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getAtendimento(id) {
      const self = this;

      const api =
        self.$store.state.api +
        "ocorrencia?with[]=paciente&with[]=solicitante&with[]=status_desc&ocorrencia_id=" +
        id;
      axios
        .get(api)
        .then((response) => {
          self.atendimento = response.data.data[0];
          self.position.lat = parseFloat(self.atendimento.latitude);
          self.position.lng = parseFloat(self.atendimento.longitude);
          self.isLoading = false;

          self.getMessages();

          setTimeout(() => {
            Echo.private("ocorrencia." + self.atendimento.ocorrencia_id).listen(
              ".Alert",
              (data) => {
                var data_message = JSON.parse(data.message);
                console.log(JSON.parse(data.message));
                if (self.user.usuario_id != data_message.usuario_id) {
                  self.messages.push(JSON.parse(data.message));
                }
                self.readMessages();
                self.rolar();
                setTimeout(() => {
                  if (self.user.usuario_id != data_message.usuario_id) {
                    const greeting = new Notification("Samu IT4D", {
                      body: "Nova mensagem no chat!",
                      icon: "http://triagem.ares-saude.com.br/img/logo.083ed3b8.png",
                    });
                    self.playSound(0.5);
                    self.$message("Chat", "Nova mensagem no chat", "info");
                  }
                  $("#chat-messages").scrollTop(
                    $("#chat-messages")[0].scrollHeight
                  );
                }, 100);
              }
            );
          }, 1000);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        });
    },
  },
  beforeDestroy() {
    const self = this;
    Echo.leave("ocorrencia." + self.atendimento.ocorrencia_id);
  },
  components: {
    Loading,
    vSelect,
  },
  props: {},
  mounted: function () {
    const self = this;
    self.isLoading = true;

    window.addEventListener("blur", function () {
      self.getMessages();
    });

    window.addEventListener("focus", function () {
      self.getMessages();
    });

    setTimeout(() => {
      self.user = self.$store.state.user;
    }, 3000);

    const ocorrenciaId = self.$route.params.id;

    console.log(
      "Subscribing to private channel for Ocorrencia ID:",
      ocorrenciaId
    );
    window.Echo.private("atendimento_status." + ocorrenciaId).listen(
      ".AtendimentoStatus",
      (e) => {
        if (e && e.ocorrencia !== undefined) {
          this.atendimento.status_desc = {
            ...this.atendimento.status_desc,
            nome: e.ocorrencia.status_desc.nome,
          };

          console.log("Status atualizado:", e.ocorrencia.status_desc.nome);
        } else {
          console.log("Evento recebido sem dados de status.");
        }
      }
    );

    if (ocorrenciaId) {
      setTimeout(() => {
        self.getAtendimento(ocorrenciaId);
      }, 1500);
    }

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    /* if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {

        this.ocorrencia.latitude = position.coords.latitude;
        this.ocorrencia.longitude = position.coords.longitude;

        this.position.lat = position.coords.latitude;
        this.position.lng = position.coords.longitude;

        self.isLoading = false;
    });
    } else {
        console.log("Geolocalização não é suportada pelo seu navegador");
        self.isLoading = false;
    } */
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  /* box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15); */
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.vue-map-container .vue-map .gm-style {
  border-radius: 30px !important;
}

.botao-solicitar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  z-index: 999999 !important;
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

/* CSS do Chat */

.chat {
  font-size: 12px !important;
}

.chat .chat-header {
  padding: 15px 20px !important;
  border-bottom: 2px solid #f4f7f6;
}

.chat .chat-header img {
  float: left !important;
  border-radius: 40px !important;
  width: 40px;
}

.chat .chat-header .chat-about {
  float: left !important;
  padding-left: 10px;
}

.chat .empty {
  min-height: 80vh;
  padding: 10px;
}

.chat .chat-history {
  padding: 20px !important;
  border-bottom: 2px solid #fff;
}

.chat .chat-history ul {
  padding: 0;
}

.chat .chat-history ul li {
  list-style: none !important;
  margin-bottom: 30px;
}

.chat .chat-history ul li:last-child {
  margin-bottom: 0px;
}

.chat .chat-history .message-data {
  margin-bottom: 15px;
}

.chat .chat-history .message-data img {
  border-radius: 40px !important;
  width: 40px;
}

.chat .chat-history .message-data-time {
  color: #434651 !important;
  padding-left: 6px;
}

.chat .chat-history .message {
  color: #444 !important;
  padding: 18px 20px !important;
  line-height: 26px !important;
  font-size: 14px !important;
  border-radius: 7px !important;
  display: inline-block !important;
  position: relative;
}

.chat .chat-history .message:after {
  bottom: 100% !important;
  left: 7% !important;
  border: solid transparent !important;
  content: " " !important;
  height: 0 !important;
  width: 0 !important;
  position: absolute !important;
  pointer-events: none !important;
  border-bottom-color: #fff !important;
  border-width: 10px !important;
  margin-left: -10px;
}

.chat .chat-history .my-message {
  background: #efefef;
  min-width: 15%;
}

.chat .chat-history .my-message:after {
  bottom: 100% !important;
  left: 30px !important;
  border: solid transparent !important;
  content: " " !important;
  height: 0 !important;
  width: 0 !important;
  position: absolute !important;
  pointer-events: none !important;
  border-bottom-color: #efefef !important;
  border-width: 10px !important;
  margin-left: -10px;
}

.chat .chat-history .other-message {
  background: #e8f1f3 !important;
  text-align: right;
  min-width: 15%;
}

.chat .chat-history .other-message:after {
  border-bottom-color: #e8f1f3 !important;
  left: 80% !important;
}

.chat .chat-message {
  padding: 20px;
}

.online,
.offline,
.me {
  margin-right: 2px !important;
  font-size: 8px !important;
  vertical-align: middle;
}

.online {
  color: #86c541;
}

.offline {
  color: #e47297;
}

.me {
  color: #1d8ecd;
}

.float-right {
  float: right;
}

.clearfix:after {
  visibility: hidden !important;
  display: block !important;
  font-size: 0 !important;
  content: " " !important;
  clear: both !important;
  height: 0;
}
.circulo {
  display: inline-flex;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  font-size: 18px;
  animation: animate 2.5s linear infinite;
}
@keyframes animate {
  0% {
    background-color: #fff;
  }

  50% {
    background-color: #25901cd2;
  }

  100% {
    background-color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VisualizarAtendimento.vue